import { useI18n } from "@/i18n";
import { en } from "./en";
import { ptBR } from "./pt-BR";

export type IntakeCopy = typeof en;

export function fmt(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

export function useIntakeCopy() {
  const { language } = useI18n();
  const locale = language === "pt-BR" ? "pt-BR" : "en";
  return { c: locale === "pt-BR" ? ptBR : en, locale, fmt } as const;
}
